import {
	DIVISION_RECOMMENDER_OPTIONS,
	INFRASTRUCTURE_OPTIONS,
	OWNERSHIP_OPTIONS,
	PageTypeEnum,
	RESIDENCE_TYPE_OPTION,
	TEMPLATE_RECOMMENDER_FIELDS,
} from '@/constant';
import {
	GetWorkerRecommenderApplicantListResponse,
	GetWorkerRecommenderDetailResponse,
	GetWorkerRecommenderListResponse,
	GetWorkerRecommenderLodgingListResponse,
	TUploadExcelRecommenderFailedItem,
	TUploadExcelRecommenderResponse,
} from '@/services';
import {
	formatDate,
	generateErrorMessagesUploadExcel,
	insertObjectIfV2,
	map,
} from '@/utils';

import { DefaultOptionType } from 'antd/es/select';

import { isNotNilOrEmpty } from 'ramda-adjunct';

export const formatWorkerRecommenderDetail = (
	input: GetWorkerRecommenderDetailResponse
) => {
	return {
		...input,
		registDt: formatDate(input?.registDt),
		updateDt: formatDate(input?.updateDt),
		typeName: DIVISION_RECOMMENDER_OPTIONS.find(
			(it) => it.value === input?.type
		)?.label,
		visaCodeName: RESIDENCE_TYPE_OPTION.find(
			(it) => it.value === input?.visaCode
		)?.label,
	};
};

export const formatWorkerRecommenderListItem = (
	input: GetWorkerRecommenderListResponse['content'][number]
) => {
	return {
		...input,
		id: input?.recommenderId,
		...insertObjectIfV2(
			typeof input?.recommenderRecommendedNumberPeople === 'number' &&
				isNotNilOrEmpty(input?.recommenderRecommendedNumberPeople),
			{
				recommenderRecommendedNumberPeople: `${input.recommenderRecommendedNumberPeople}명`,
			}
		),
		recommenderRegistDt: formatDate(input?.recommenderRegistDt),
		recommenderUpdateDt: formatDate(input?.recommenderUpdateDt),
		recommenderBirthDate: formatDate(input?.recommenderBirthDate),
	};
};

export const formatWorkerRecommenderList = (
	input: GetWorkerRecommenderListResponse['content']
) => {
	return map(input, formatWorkerRecommenderListItem);
};

export const formatWorkerRecommenderApplicantDetail = (
	data: GetWorkerRecommenderApplicantListResponse['content'][number]
) => {
	return {
		...data,
		birthDate: formatDate(data?.birthDate),
		applicantRecommenderRelationship:
			data?.applicantRecommenderRelationship || data?.recommenderRelationship,
	};
};

export const formatWorkerRecommenderApplicantList = (
	input: GetWorkerRecommenderApplicantListResponse['content']
) => {
	return map(input, formatWorkerRecommenderApplicantDetail);
};

export const formatUploadExcelRecommenderFailedItem = (
	input: TUploadExcelRecommenderFailedItem
) => {
	// because in template, row 1 and row 2 of spouseName  is the same, so one row deleted, we need to duplicate it again to show in error message
	const customTemplateRecommenderFields = [
		...TEMPLATE_RECOMMENDER_FIELDS.map((field) =>
			field.value === 'spouseName'
				? { label: `${field.label}_${field.label}`, value: 'spouseName' }
				: field
		),
	];
	return {
		...input.data,
		reasonFailure: generateErrorMessagesUploadExcel({
			response: {
				errorList: input.errorList,
			},
			templateFields: customTemplateRecommenderFields,
			pageType: PageTypeEnum.RECOMMENDER,
		}),
	};
};

export const formatUploadExcelRecommenderFailedList = (
	input: TUploadExcelRecommenderResponse
) => {
	return map(input, formatUploadExcelRecommenderFailedItem);
};

export const formatWorkerRecommenderLodgingDetail = (
	data: GetWorkerRecommenderLodgingListResponse['content'][number]
) => {
	const ownership = OWNERSHIP_OPTIONS.find(
		(e: DefaultOptionType) => e.value === data.ownershipType
	);
	const facility = INFRASTRUCTURE_OPTIONS.find(
		(e: DefaultOptionType) => e.value === data.facilityType
	);
	return {
		...data,
		ownershipTypeName: ownership?.label || '',
		facilityTypeName: facility?.label || '',
		residentCnt: data.residentCnt || 0,
	};
};

export const formatWorkerRecommenderLodgingList = (
	input: GetWorkerRecommenderLodgingListResponse['content']
) => {
	return map(input, formatWorkerRecommenderLodgingDetail);
};
